import { ON_KEY_CALL, SUPPORT_HUB_MODE, SUPPORT_INNEAR_MODE } from "../../const/area"
import { VOICE_CODE } from "../../const/config"

export default {
  namespaced: true,
  state: {
    ticketConfig: {
      pageTitle: '网约巴士', // 页面标题
      isShowGuide: false, // 是否暂时乘车指引
      guideLink: '', // 乘车指引链接
      protocolTitle: '', // 协议标题
      protocolContent: '', // 协议内容
      loginTitle: '', // 登录标题
      loginLogoUrl: '', // 登录logo
      clientContext: '', // 用户协议
      privacyContext: '', // 隐私协议
    },
    callInfo: null, // 一键叫车
    showCall: false, // 是否显示首页一键叫车卡片
    cityConfig: {
      modeAreaInternal: SUPPORT_INNEAR_MODE.YES, // 默认开启
      modePointToArea: SUPPORT_HUB_MODE.NO, // 默认不开启
      oneKeyCall: ON_KEY_CALL.ENABLE, // 默认开启
      voiceCode: VOICE_CODE.DISABLE, // 默认关闭
    }
  },
  getters: {
    ticketConfig: state => state.ticketConfig,
    callInfo: state => state.callInfo,
    showCall: state => state.showCall,
    cityConfig: state => state.cityConfig,
    // 该城市是否启用“一键叫车”功能
    enableCall: state => {
      const { oneKeyCall } = state.cityConfig || {}
      return oneKeyCall === ON_KEY_CALL.ENABLE
    },
    // 该城市是否启用语音验证码
    enableVoiceCode: state => {
      const { voiceCode } = state.cityConfig || {}
      return voiceCode === VOICE_CODE.ENABLE
    }
  },
  mutations: {
    setTicketConfig(state, payload) {
      state.ticketConfig = payload
    },
    setCallInfo(state, payload) {
      state.callInfo = payload
    },
    setShowCall(state, payload) {
      state.showCall = payload
    },
    setCityConfig(state, payload) {
      state.cityConfig = payload
    },
  },
  actions: {
    setTicketConfig({ commit }, payload) {
      commit('setTicketConfig', payload)
    },
    setCallInfo({ commit }, payload) {
      commit('setCallInfo', payload)
    },
    setCityConfig({ commit }, payload) {
      commit('setCityConfig', payload)
    },
  }
}
